import React, { Component } from 'react';
import Tibbit_base from '@appblocks/frontend/client/Components/TPP/Tibbit_base';

export default class Tibbit_connector_wide extends Tibbit_base {
    render() {
        return (
            <g id="connector_wide" {...this.props} className="tibbit">
                <rect className="draggable" x="0" y="0" width="96.63" height="45" transform="translate(46, 2) rotate(90)" />
                <polygon className="moduleColor_connector" points="44.633,99.169 44.633,0 9.877,0 9.877,1.401 2.258,1.401 2.258,0 0,0 0,99.127 2.258,99.127 &#xA;&#9;&#9;2.258,97.957 9.877,97.957 9.877,99.169 " />

                <rect className="recess" x="2.258" y="1.401" width="7.62" height="96.556" />
                <rect className="recess" x="40.665" y="5.093" width="3.969" height="89.623" />

                <rect className="labelColor" x="13.264" y="3.868" width="24.553" height="91.62" />

                <g id="label">
                    <text transform="matrix(0 -1 1 0 22 8)" className="label" textAnchor="end" id="num">{this.props.num}</text>
                    <text transform="matrix(0 -1 1 0 23 93)" className="desc" id="desc">
                        {this.renderDescriptions()}
                    </text>
                </g>
                <polygon className="tibbitStroke" points="44.633,99.169 44.633,0 9.877,0 9.877,1.401 2.258,1.401 2.258,0 0,0 0,99.127 2.258,99.127 &#xA;&#9;&#9;2.258,97.957 9.877,97.957 9.877,99.169 " />
                {this.renderWiring()}
            </g>
        );
    }
}
